import { Environment } from '@atlassiansox/bxpkit-core';

export function getSiteDomain() {
  if (!Environment.isProduction()) {
    return '.jira-dev.com';
  } else {
    return '.atlassian.net';
  }
}
